<template>
  <div>
    <el-header :class="!isActive && $store.state.headerIndex === 0 ? 'native' : ''" v-if="$store.state.isMobile == 2">
      <div class="logo">
        <img src="../assets/img/logo-new.png" alt />
      </div>
      <div class="title">
        <el-menu :default-active="$route.meta.name" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          :router="router">
          <el-menu-item index="home" @click="navigateTo('/')"><span>{{ navText.home }}</span></el-menu-item>
          <el-menu-item index="company" class="show"><span @click="navigateTo('/solutioNav')">{{ navText.solution }}</span>
            <HeaderHover class="outer" :isActive="isActive"></HeaderHover>
          </el-menu-item>
          <el-menu-item @click="navigateTo('/case')" index="case"><span>{{ navText.caseStudy }}</span></el-menu-item>
          <el-menu-item @click="navigateTo('/news')" index="news"><span>{{ navText.news }}</span></el-menu-item>
          <el-menu-item @click="navigateTo('/about')" index="about"><span>{{ navText.about }}</span></el-menu-item>
          <el-menu-item @click="navigateTo('/join')" index="join"><span>{{ navText.join }}</span></el-menu-item>
        </el-menu>
        <div class="phone">
          <div class="line"></div>
          <el-dropdown class="language-switch" trigger="click" @command="changeLanguage">
            <span class="el-dropdown-link" :class="{ 'shadow': !isActive }">
              {{ currentLanguageLabel }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Chinese">中文</el-dropdown-item>
              <el-dropdown-item command="English">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div class="line"></div>
          <img v-if="isActive" src="../assets/img/phone.png" alt />
          <img v-else src="../assets/img/phone_native.png" alt />
          <div :class="{ 'shadow': !isActive }">0512-67611188</div>
          <div style="transform: translateX(50px);cursor: pointer" v-if="($route.path === '/news-edit')"
            @click="$router.push('/news-preview')">{{ isEnglish ? 'Preview' : '预览' }}</div>
          <div style="transform: translateX(50px);cursor: pointer" v-if="($route.path === '/news-preview')"
            @click="$router.push('/news-edit')">{{ isEnglish ? 'Edit' : '编辑' }}</div>
        </div>
        <i v-if="$store.state.editStatus === 2" @click="$store.commit('setEditStatus', 0)"
          class="el-icon-circle-close close"></i>
      </div>
    </el-header>
   
  </div>
</template>

<script>
import HeaderHover from './HeaderHover.vue';
export default {
  name: 'Header',
  components: {
    HeaderHover,
  },
  data() {
    return {
      isActive: this.$route.name != 'Home',
      // router: true,//是否使用 vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转
      router: false,
      defaultActive: this.$route.path,
    
    
      pageName: '首页'
      // defaultActive: '/',
    };
  },
  computed: {
    isEnglish() {
      return this.$store.state.language === 'English';
    },
    navText() {
      if (this.isEnglish) {
        return {
          home: 'Home',
          solution: 'Products & Solutions',
          caseStudy: 'Case Studies',
          news: 'News',
          about: 'Culture',
          join: 'Join Us',
        };
      }

      return {
        home: '首页',
        solution: '产品与方案',
        caseStudy: '典型案例',
        news: '资讯动态',
        about: '园测文化',
        join: '加入我们',
      };
    },
    currentLanguageLabel() {
      return this.isEnglish ? 'English' : '中文';
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.routeNmae = this.$route.path;
        this.defaultActive = val.path;
        this.isActive = this.$route.name != 'Home';
        this.headerName();
        // document.getElementsByClassName('footer')[0].style.display = 'block';
      },
      // immediate: true,
    },
  },
  mounted() {
    this.routeNmae = this.$route.path;
    this.headerName();
    this.$EventBus.$on('changeHeader', (val) => {
      this.isActive = val;

    });

  },
  methods: {
    headerName() {
      switch (this.routeNmae) {
        case '/home':
          this.pageName = '首页'
          break;
        case '/solutioNav':
          this.pageName = '产品与方案'
          break;
        case '/case':
          this.pageName = '典型案例'
          break;
        case '/news':
          this.pageName = '资讯动态'
          break;
        case '/about':
          this.pageName = '园测文化'
          break;
        case '/join':
          this.pageName = '加入我们'
          break;

        default:
          this.pageName = '园测信息科技股份有限公司'
      }
    },

    handleSelect(key) {
      if (key == 'company') {
        return;
      } else if (key != 'home') {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    navigateTo(url) {
      // this.$router.push(url);
      // 解决路由重复跳转同一页面的报错
      this.$router.push(url, () => { });
    },
    changeLanguage(language) {
      this.$store.dispatch('changeLanguage', language);
    },
  },
};
</script>

<style lang="scss" scoped>


@media screen and (min-width:767px) {

  .el-header {
    position: fixed;
    top: 0;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 60px !important;
    box-shadow: 0px 2px 8px 0px rgba(5, 28, 55, 0.42);
    background-color: #fff;


    .logo {
      width: 132px;
      padding: 20px 0;
      margin-left: 200px;
      display: flex;
      align-items: center;

      img {
        width: 100%;
        transform: scale(2);
      }
    }

    .title {
      display: flex;
    }

    .phone {
      margin-right: 200px;

      .line {
        width: 1px;
        height: 20px;
        background: #aaa;
        opacity: 0.6;
        margin: 0 20px;
      }

      padding: 20px 0;
      display: flex;
      align-items: center;

      img {
        width: 20px;
        margin-right: 20px;
      }

      >div {
        height: 21px;
        font-size: 18px;
        font-family: Alibaba PuHuiTi 2;
        font-weight: 600;
        color: #d7000f;
        line-height: 21px;
      }

      span {
        font-weight: normal;
      }

      .language-switch {
        display: flex;
        align-items: center;

        .el-dropdown-link {
          cursor: pointer;
          color: inherit;
          font-size: 18px;
          font-family: Alibaba PuHuiTi 2;
          font-weight: 600;
          display: flex;
          align-items: center;
        }
      }
    }

    .show {
      .outer {
        display: none;
        position: absolute;
        left: -15px;
        top: 60px;
        animation: fadeInDownBig;
        /* referring directly to the animation's @keyframe declaration */
        animation-duration: 0.5s;
        /* don't forget to set a duration! */
      }
    }

    .show:hover {
      .outer {
        display: block;
        z-index: -1;
      }
    }

    .el-menu--horizontal {
      border-bottom: none !important;
      display: flex;
      align-items: center;

      .el-menu-item {
        font-size: 18px;
        display: flex;
        align-items: center;
        color: #06387f;

        &.is-active {
          color: #d7000f !important;
          background-color: inherit !important;
          border-width: 3px;
          border-color: #d7000f;
        }
      }

      .el-menu-item:hover {
        background-color: inherit;
        color: #d7000f;

        // 底部边框动画
        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: -1px;
          width: 100%;
          height: 3px;
          background-color: #d7000f;
          animation: increaseBorder 1s linear;
        }

        &.is-active {
          border: none;
        }
      }
    }

    .el-menu--horizontal:hover {
      .el-menu-item {
        &.is-active {
          border: none;
        }
      }
    }
  }

  .native {
    background: inherit;

    .phone {
      >div {
        color: #fff;
      }
    }

    .shadow {
      text-shadow: #666 2px 2px 2px;

    }

    .el-menu--horizontal {
      background: inherit;

      .el-menu-item {
        color: #fff;

        span {
          text-shadow: #666 2px 2px 2px;
        }

        &.is-active {
          color: #fff !important;
        }
      }

      .el-menu-item:hover {
        color: #fff;
      }
    }
  }

  .close {
    position: fixed;
    right: 20px;
    top: 16px;
    font-size: 30px;
    color: #666;
  }
}
span {
  font-weight: 700;
}
</style>
